import {sharedCampaigns} from '@cl/shared';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DTCompoundConditionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {CompoundConditionCardData} from '../../scratchpad/compoundConditionCardScratchpad.types';
import {CLStore} from 'common/src/redux/store';
import {FALLBACK_OUTPUT_ID} from 'common/src/modules/campaignAnalytics/campaignAnalytics.types';

function createDefaultCompoundConditionCard(): CompoundConditionCardData {
  return {
    id: NO_NODE_ID,
    type: NodeType.COMPOUND_CONDITION,
    inputs: [],
    outputs: [
      {
        id: FALLBACK_OUTPUT_ID,
        name: 'Fallback',
        type: OutputType.Fallback,
        nodeId: NO_NODE_ID,
        sections: [],
      },
    ],
    randomizeOutputsEvaluationOrder: true,
  };
}

/**
 * Gets an existing compound condition card by ID, or creates a new default one.
 * @param cardId - The card ID to fetch, or 0/undefined for a new card
 * @param store - Redux store
 * @returns The compound condition card (existing or new), fully mutable
 */
async function getOrCreateCompoundConditionCard(
  cardId: number | undefined,
  store: CLStore,
): Promise<CompoundConditionCardData> {
  const resolvedCardId = cardId && cardId > NO_NODE_ID ? cardId : NO_NODE_ID;

  if (resolvedCardId) {
    const state = store.getState();
    const campaignId = state.campaignPage.campaignTree.campaign?.id;

    if (!campaignId) {
      throw new Error('Campaign ID not found');
    }

    const existingCard = sharedCampaigns.nodesRef.value[resolvedCardId] as DTCompoundConditionNode;

    if (!existingCard) {
      throw new Error(`Card with id ${resolvedCardId} not found`);
    }

    return {
      ...existingCard,
    };
  }

  return createDefaultCompoundConditionCard();
}

export default getOrCreateCompoundConditionCard;
export {createDefaultCompoundConditionCard};
